import React, { Component } from "react";
import PropTypes from "prop-types";

export default class IconWithIndicator extends Component {
  render() {
    let { displayIndicator, indicator, icon, ...restProps } = this.props;
    let displayInfo = displayIndicator;

    if (displayInfo) {
      return (
        <div style={{ position: "absolute" }} {...restProps}>
          {icon}
          <div
            style={{
              position: "absolute",
              top: "0",
              right: "0",
              borderRadius: "50%",
              backgroundColor: "#395a5a",
              width: "18px",
              height: "18px",
              color: "#fff",
              textAlign: "center",
              lineHeight: "20px",
              fontSize: "8px",
              margin: "-7px -7px 0 0 ",
            }}
          >
            {indicator}
          </div>
        </div>
      );
    } else {
      return React.cloneElement(icon, restProps);
    }
  }

  static propTypes = {
    displayIndicator: PropTypes.any,
    indicator: PropTypes.any,
    icon: PropTypes.any,
  };
}
